import {signinAdmin, signOutDataBase} from '@/repositories/admin.repository'

import {updateStatusTotem} from '@/controllers/totem.controller'
import adminStore from "@/store/admin.store"


const admin = adminStore.getters.admin;

export const signin = async (email, password) => {
 const data = await signinAdmin(email, password)

 if (!data) {
   return null
 }

 return data
}


export const signOut = async () => {
  const {selectedTotem} = admin;

  await updateStatusTotem(selectedTotem)

  signOutDataBase()
}

